<ng-container *transloco="let t; read: 'mustEnableMfa'">
    <div class="modal">
        <h1 class="modal__heading">{{ t("heading") }}</h1>
        <div class="modal__content">{{ t("content") }}</div>

        <div class="modal__actions">
            <button class="modal__actions__logout" type="button" (click)="logout()">{{ t("logout") }}</button>
        </div>
    </div>
</ng-container>
